/**
 * Header logo display size - keep in sync with nexys-v1-admin
 * `src/pages/Projects/logoDisplay.ts`.
 */
export const LOGO_TARGET_WIDTH = 180
export const LOGO_MIN_HEIGHT = 44
export const LOGO_MAX_HEIGHT = 64
export const LOGO_MAX_WIDTH = 320

export function logoDisplaySize(naturalWidth: number, naturalHeight: number): { width: number; height: number } {
  if (!naturalWidth || !naturalHeight) {
    return { width: LOGO_TARGET_WIDTH, height: LOGO_MIN_HEIGHT }
  }
  const aspect = naturalWidth / naturalHeight
  let height = Math.min(LOGO_MAX_HEIGHT, Math.max(LOGO_MIN_HEIGHT, LOGO_TARGET_WIDTH / aspect))
  let width = height * aspect
  if (width > LOGO_MAX_WIDTH) {
    width = LOGO_MAX_WIDTH
    height = width / aspect
  }
  return { width, height }
}
